import React, { useEffect } from 'react';
import { NavLink, Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { AdminLayout } from '../components/AdminLayout';
import { QuestionsManagement } from './system-settings/QuestionsManagement';
import { SubscriptionEventsView } from './system-settings/SubscriptionEventsView';
import { SubscriptionPlansManagement } from './system-settings/SubscriptionPlansManagement';
import { UsersManagement } from './system-settings/UsersManagement';

export function SystemSettingsPage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.role !== 'admin') {
      navigate('/', { replace: true });
    }
  }, [user?.role, navigate]);

  if (!user || user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  const headerActions = (
    <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => navigate('/')}>
      <i className="fas fa-arrow-left me-1" aria-hidden="true" /> Back to practice workspace
    </button>
  );

  return (
    <AdminLayout
      title="System Settings"
      subtitle="Manage users, subscriptions, and generated questions."
      headerActions={headerActions}
    >
      <div className="row g-3">
        <div className="col-12 col-lg-3">
          <div className="card card-outline card-secondary">
            <div className="card-header border-0">
              <h3 className="card-title h6 mb-0">Sections</h3>
            </div>
            <div className="list-group list-group-flush">
              <NavLink to="users" className={({ isActive }) => `list-group-item list-group-item-action ${isActive ? 'active' : ''}`}>
                <i className="fas fa-users me-2" aria-hidden="true" /> Users
              </NavLink>
              <NavLink to="subscriptions" className={({ isActive }) => `list-group-item list-group-item-action ${isActive ? 'active' : ''}`}>
                <i className="fas fa-tags me-2" aria-hidden="true" /> Plans
              </NavLink>
              <NavLink
                to="subscription-events"
                className={({ isActive }) => `list-group-item list-group-item-action ${isActive ? 'active' : ''}`}
              >
                <i className="fas fa-clipboard-list me-2" aria-hidden="true" /> Subscription logs
              </NavLink>
              <NavLink to="questions" className={({ isActive }) => `list-group-item list-group-item-action ${isActive ? 'active' : ''}`}>
                <i className="fas fa-question-circle me-2" aria-hidden="true" /> Questions
              </NavLink>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-9">
          <Routes>
            <Route path="users" element={<UsersManagement />} />
            <Route path="subscriptions" element={<SubscriptionPlansManagement />} />
            <Route path="subscription-events" element={<SubscriptionEventsView />} />
            <Route path="questions" element={<QuestionsManagement />} />
            <Route path="*" element={<Navigate to="users" replace />} />
          </Routes>
        </div>
      </div>
    </AdminLayout>
  );
}
